import { NgIf } from '@angular/common';
import { Component, input } from '@angular/core';

import { MovieLoadingComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie } from '@usheru-hff/shared/domain';
/**
 * Component to display the title from a movie.
 *
 * //TODO barbeitoalex propostal - fix title to trTitle
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-movie-title',
  templateUrl: './movie-title.component.html',
  styleUrls: ['./movie-title.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class MovieTitleComponent implements MovieLoadingComponent {
  /**
   * @docsNotRequired
   */
  readonly movie = input<Movie | null>(null);
  readonly isLoadingData = input(false);
}
